import React from 'react';
import { fallbackContent } from '../hooks/useContent';

const Services = ({ items = fallbackContent.services }) => {
  return (
    <section id="services" className="py-20 lg:py-28 bg-[#f5f5f8]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl">
          <p className="section-label text-[#c9a227] mb-3">Our Services</p>
          <h2 className="font-display font-bold text-[#12263f] text-4xl lg:text-5xl">End-to-end consultancy &amp; technology.</h2>
          <p className="mt-4 text-gray-600">From tenders and certifications to registrations and software — one accountable team across the entire journey.</p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((s, i) => (
            <div key={i} className="group bg-white rounded-2xl p-7 border border-gray-100 hover:border-[#c9a227]/40 hover:shadow-lg transition-all duration-300">
              <span className="font-display font-bold text-[#c9a227] text-sm">{s.num}</span>
              <h3 className="font-display font-bold text-[#12263f] text-lg mt-4 group-hover:text-[#1c3a5e] transition-colors">{s.title}</h3>
              <p className="mt-2.5 text-gray-600 text-[15px] leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
